import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { ChatMemberApi, ChatsApi } from "../../../api";
import { ChatMembersType, ChatSliceType, ChatsTypes } from "../../../Types/MessengerType";

const initialState: ChatSliceType = {
  allMembers: [],
  chatMembers: [],
  chats: [],
  currentUser: null,
  selectedUser: null,
  isTyping: false,
  activeCallUser: null,
};

export const fetchChatMemberApiData = createAsyncThunk<ChatMembersType[], void, {}>("/api/chatmember", async () => {
  const response = await axios.get(ChatMemberApi);
  return response.data;
});

export const fetchChatsApiData = createAsyncThunk<ChatsTypes[], void, {}>("/api/chats", async () => {
  const response = await axios.get(ChatsApi);
  return response.data;
});

const ChatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    setAllMembers: (state, action) => {
      state.allMembers = action.payload;
    },
    setSelectedUser: (state, action) => {
      state.selectedUser = action.payload;
    },
    setChats: (state, action) => {
      state.chats = action.payload;
    },
    fetchChatMemberAsync: (state) => {
      if (state.allMembers.length > 0) {
        state.currentUser = state.allMembers[0];
        state.chatMembers = state.allMembers;
      }
    },
    changeChat: (state, action) => {
      let newUser = state.allMembers.find((x: { id: number }) => x.id === action.payload);
      state.selectedUser = newUser;
    },
    createNewChatAsync: (state, action) => {
      let conversation = {
        id: action.payload.chats.length + 1,
        users: [action.payload.currentUserId, action.payload.selectUser],
        lastMessageTime: "-",
        messages: [],
      };
      state.chats.splice(0, 0, conversation);
      if (state.allMembers.length > 0) {
        let selectUsers = state.allMembers.find((x: { id: number }) => x.id === action.payload.selectedUserId);
        state.selectedUser = selectUsers;
      }
    },
    sendMessageAsync: (state, action) => {
      let chat = state.chats.find((x: ChatsTypes) => x.users.includes(action.payload.currentUserId) && x.users.includes(action.payload.selectedUserId));
      if (chat) {
        chat.messages.push({
          sender: action.payload.currentUserId,
          time: action.payload.time,
          class: "replies",
          stickers: action.payload.stickers,
          text: action.payload.messageInput,
          status: true,
        });
        chat.time = action.payload.time;
        let chats_data = state.chats.filter((x: { id?: number }) => x.id !== chat?.id);
        chats_data.splice(0, 0, chat);
        if (state.allMembers.length > 0) {
          let selectedUser = state.allMembers.find((x: { id: number }) => x.id === action.payload.selectedUserId);
          state.selectedUser = selectedUser;
        }
      }
    },
    replyByUserAsync: (state, action) => {
      let chat = state.chats.find((x: ChatsTypes) => x.users.includes(action.payload.currentUserId) && x.users.includes(action.payload.selectedUserId));
      if (chat) {
        chat.messages.push({
          sender: action.payload.selectedUserId,
          time: action.payload.time,
          class: "sent",
          text: action.payload.replyMessage,
          status: true,
        });
        chat.lastMessageTime = action.payload.time;
        let chats_data = state.chats.filter((x: { id?: number }) => x.id !== chat?.id);
        chats_data.splice(0, 0, chat);
      }
    },
    typingMessage: (state, action) => {
      state.isTyping = action.payload;
    },
    setActiveCallUser: (state, action) => {
      state.activeCallUser = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchChatMemberApiData.fulfilled, (state, action) => {
      state.allMembers = action.payload;
      state.chatMembers = action.payload;
    });
    builder.addCase(fetchChatsApiData.fulfilled, (state, action) => {
      state.chats = action.payload;
    });
  },
});

export const { fetchChatMemberAsync, changeChat, setAllMembers, createNewChatAsync, setSelectedUser, setChats, sendMessageAsync, replyByUserAsync, typingMessage, setActiveCallUser } = ChatSlice.actions;
export default ChatSlice.reducer;
